import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useCitizenSession } from "../session/b2cSession";
import { LoadingScreen } from "./CitizenUi";

export default function RequireAuth({ children }) {
  var session = useCitizenSession();
  var location = useLocation();

  if (session.status === "loading") {
    return (
      <div className="citizen-shell citizen-shell--loading">
        <LoadingScreen message="Loading your account…" />
      </div>
    );
  }

  if (session.status !== "authenticated") {
    var next = location.pathname + location.search;
    return <Redirect to={"/citizen/login?next=" + encodeURIComponent(next)} />;
  }

  return children;
}
